import React, { useState } from 'react'

import { Trans } from '@lingui/macro'
import { Button } from 'components/UI/Button/Button'
import { useDispatch, useSelector } from 'react-redux'


import { InputText } from 'components/UI/InputText/InputText';
import { IdCashDesksState, typeCashDesksFilters } from 'model/dashboardCashDesks/dCashDesksReducer';
import { dCashDesksSetFiltersAC } from 'model/dashboardCashDesks/dCashDesksActionCreators';


// Type
export type typeDCashDesksFilters = {
    setOpenFilterBar: React.Dispatch<React.SetStateAction<boolean>>
    setIsActiveFilters: React.Dispatch<React.SetStateAction<boolean>>
}


// Component
export const DCashDesksFilters: React.FC<typeDCashDesksFilters> = ({ setOpenFilterBar, setIsActiveFilters }) => {

    const dispatch = useDispatch()

    const filters = useSelector((state: { dCashDesks: IdCashDesksState }) => state.dCashDesks.filters)

    //posHardwareModel Input
    const [ posHardwareModelValue, setPosHardwareModel ] = useState(filters.posHardwareModel || '')
    const onChangePosHardwareModel = (e: any) => {
        setPosHardwareModel(e.target.value)
    }


    //posHardwareSN Input
    const [ posHardwareSN, setPosHardwareSN ] = useState(filters.posHardwareSerialNumber || '')
    const onChangePosHardwareSN = (e: any) => {
        setPosHardwareSN(e.target.value)
    }

    //posHardwareSN Input
    const [ fiscalCardIdValue, setFiscalCardIDValue ] = useState(filters.fiscalCardId || '')
    const onChangeFiscalCardId = (e: any) => {
        setFiscalCardIDValue(e.target.value)
    }

    const checkIsChangedFiltersHandler = (newFilters: typeCashDesksFilters): boolean => {
        // eslint-disable-next-line eqeqeq
        return !( newFilters.fiscalCardId == filters.fiscalCardId && newFilters.posHardwareModel == filters.posHardwareModel
            && newFilters.posHardwareSerialNumber === filters.posHardwareSerialNumber
        )
    }

// Submit form
    const onSubmitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const newFilters: typeCashDesksFilters = {
            fiscalCardId: fiscalCardIdValue.trim() === '' ? null : fiscalCardIdValue.trim(),
            posHardwareModel: posHardwareModelValue.trim() === '' ? null : posHardwareModelValue.trim(),
            posHardwareSerialNumber: posHardwareSN.trim() === '' ? null : posHardwareSN.trim()

        }
        if (checkIsChangedFiltersHandler(newFilters)) {
            await dispatch(dCashDesksSetFiltersAC(newFilters))
            setIsActiveFilters(true)
        }
        setOpenFilterBar(false)

    }

    const onRestoreHandler = () => {

        setPosHardwareSN('')
        setPosHardwareModel('')
        setFiscalCardIDValue('')
        setIsActiveFilters(false)
        dispatch(dCashDesksSetFiltersAC({ posHardwareSerialNumber: null, posHardwareModel: null, fiscalCardId: null }))
    }

    return (
        <>
            <form onSubmit={ (e) => onSubmitHandler(e) }>
                <div className="flex flex-col gap-4">
                    <div>
                        <InputText id={ 'posHardwareModel' } label={ <Trans>Cash Desk's Model</Trans> }
                                   onChange={ onChangePosHardwareModel } value={ posHardwareModelValue }
                                   maxLength={ 100 }
                        />
                    </div>
                    <div>
                        <InputText id={ 'posHardwareSerialNumber' } label={ <Trans>Serial Number</Trans> }
                                   onChange={ onChangePosHardwareSN } value={ posHardwareSN }
                                   maxLength={ 100 }
                        />
                    </div>

                    {process.env.REACT_APP_CUSTOMER !== 'SKAPPSK' && <div>
                        <InputText id={ 'fiscalCardID' } label={ <Trans>Fiscal card Id</Trans> }
                                   onChange={ onChangeFiscalCardId } value={ fiscalCardIdValue }
                                   maxLength={ 100 }/>
                    </div> }


                    <div className="flex flex-col sm:flex-row gap-4 mt-4">
                        <Button buttonClassName="w-full" secondary={ true } type="button"
                                label={ <Trans>Clear</Trans> }
                                onClick={ onRestoreHandler }/>
                        <Button buttonClassName="w-full" type="submit" label={ <Trans>Apply</Trans> }/>
                    </div>

                </div>
            </form>
        </>
    )
}
